import { JSX } from 'react'

import { IconProps } from '../../icon'

const Resources: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M33.2051 9.64103H24.2944C23.8349 8.67282 22.8503 8 21.7179 8H18.4359C17.2872 8 16.319 8.67282 15.8595 9.64103H15.1538C11.7569 9.64103 9 12.3979 9 15.7949V33.8462C9 37.2431 11.7569 40 15.1538 40H33.2051C36.6021 40 39.359 37.2431 39.359 33.8462V15.7949C39.359 12.3979 36.6021 9.64103 33.2051 9.64103ZM18.4359 10.4615H21.7179C21.9477 10.4615 22.1282 10.6421 22.1282 10.8718V15.4503L20.6185 14.6954C20.4379 14.6133 20.2574 14.5641 20.0769 14.5641C19.8964 14.5641 19.6995 14.6133 19.5354 14.6954L18.0256 15.4503V10.8718C18.0256 10.6421 18.2062 10.4615 18.4359 10.4615ZM36.8974 33.8462C36.8974 35.881 35.24 37.5385 33.2051 37.5385H15.1538C13.119 37.5385 11.4615 35.881 11.4615 33.8462V15.7949C11.4615 13.76 13.119 12.1026 15.1538 12.1026H15.5641V17.4359C15.5641 17.8626 15.7774 18.2564 16.1549 18.4862C16.5159 18.7159 16.9754 18.7323 17.3528 18.5354L20.0933 17.1733L22.8338 18.5354C23.0144 18.6174 23.1949 18.6667 23.3754 18.6667C23.6051 18.6667 23.8185 18.601 24.0154 18.4862C24.3764 18.2564 24.6062 17.8626 24.6062 17.4359V12.1026H33.2215C35.2564 12.1026 36.9138 13.76 36.9138 15.7949V33.8462H36.8974Z'
      fill='black'
    />
    <path
      d='M31.5641 22.7692H16.7949C16.122 22.7692 15.5641 23.3272 15.5641 24C15.5641 24.6728 16.122 25.2308 16.7949 25.2308H31.5641C32.2369 25.2308 32.7949 24.6728 32.7949 24C32.7949 23.3272 32.2369 22.7692 31.5641 22.7692Z'
      fill='black'
    />
    <path
      d='M25 29.3333H16.7949C16.122 29.3333 15.5641 29.8913 15.5641 30.5641C15.5641 31.2369 16.122 31.7949 16.7949 31.7949H25C25.6728 31.7949 26.2308 31.2369 26.2308 30.5641C26.2308 29.8913 25.6728 29.3333 25 29.3333Z'
      fill='black'
    />
  </svg>
)

export default Resources
